import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Accordion from '@r1-frontend/ui-react/deprecated/Accordion';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { SectionTitle } from '~/src/features/mania/styled';

export const QaContainer = styled(WideContainer)`
    flex-direction: column;
`;

export const QaTitle = styled(SectionTitle)`
    margin-bottom: 24px;
`;

export const QaWrapper = styled.div`
    flex-direction: column;
`;

export const QaAccordion = styled(Accordion)`
    &:not(:last-child) {
        margin-bottom: 12px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        > div:first-child {
            ${FONTS.L};
        }
    }
`;

export const QaAnswer = styled.p`
    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.S};
    }
`;
